import {
  REGULAR_AI_SESSION_TYPE,
  AUDIO_RECORDING_SESSION_TYPE,
} from "components/ai-session-review/constants";
import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export const DEFAULT_AI_SESSION_TYPES = [
  {
    label: REGULAR_AI_SESSION_TYPE,
    price: 0.0,
    enabled: true,
    align_min: 30,
    length_min: 60,
    invite_only: true,
    padding_min: 5,
    only_followup: false,
  },
  {
    label: AUDIO_RECORDING_SESSION_TYPE,
    price: 0.0,
    enabled: true,
    align_min: 30,
    length_min: 60,
    invite_only: true,
    padding_min: 5,
    only_followup: false,
  },
];

export default async function postAppointmentTypes(nextTypes: SessionType[]) {
  // check if nextTypes missing DEFAULT AI types (REGULAR_AI_SESSION_TYPE and AUDIO_RECORDING_SESSION_TYPE)
  const isMissingDefaultAITypes =
    nextTypes.find(
      (el) =>
        el.label === REGULAR_AI_SESSION_TYPE ||
        el.label === AUDIO_RECORDING_SESSION_TYPE,
    ) === undefined;

  const sessionTypesToPost = !isMissingDefaultAITypes
    ? nextTypes
    : [...nextTypes, ...DEFAULT_AI_SESSION_TYPES];

  // add back the default AI types if missing
  const response = await fetchOrchidAPI(
    `/api/scheduler/v1/appointment_types/`,
    {
      method: "POST",
      body: JSON.stringify(sessionTypesToPost),
    },
  );
  if (!response.ok) {
    throw new Error(getErrorDetail(await response.text()));
  }
  return sessionTypesToPost;
}
